import { getAuthHeaders, tempMeeApi } from '~/services/api';
import {
  IGetCandidateOnsiteInterviewListApiResponse,
  IGetCandidateOnsiteInterviewListPayload,
} from '../types';

export const getCandidateOnsiteInterviewList = async (
  payload: IGetCandidateOnsiteInterviewListPayload,
): Promise<IGetCandidateOnsiteInterviewListApiResponse> => {
  const headers = await getAuthHeaders();
  const response = await tempMeeApi.get<IGetCandidateOnsiteInterviewListApiResponse>(
    `/offices/postings/${payload.postingId}/candidates/${payload.professionalId}/onsite-interviews`,
    { headers },
  );
  return response.data;
};
